import React, { useMemo } from "react";
import dateFormat from "dateformat";
import { getPrevMonth, getNextMonth, formatCurrentDate, isPrevMonthDisabled } from "@utils/date/racketRentDate";
import { useBookingWindow } from "@/hooks/useBookingWindow";
import styles from "./DateNavigation.module.scss";
import arrowLeftIcon from "@assets/icons/arrowCalendarLeft.svg";
import arrowRightIcon from "@assets/icons/arrowCalendarRight.svg";

interface DateNavigationProps {
  viewedDate: string;
  onMonthChange: (newViewedDate: string) => void;
}

export const DateNavigation: React.FC<DateNavigationProps> = ({ viewedDate, onMonthChange }) => {
  const currentDate = formatCurrentDate(viewedDate);
  const disablePrevButton = isPrevMonthDisabled(viewedDate);

  // Граница продаж с бэка (учитывает ранний доступ тренеров)
  const { maxDate } = useBookingWindow();
  const maxTime = maxDate.getTime();
  const disableNextButton = useMemo(() => {
    const max = new Date(maxTime);
    const viewed = new Date(Date.parse(viewedDate));
    return (
      viewed.getFullYear() > max.getFullYear() ||
      (viewed.getFullYear() === max.getFullYear() && viewed.getMonth() >= max.getMonth())
    );
  }, [viewedDate, maxTime]);

  const handlePrevMonth = () => {
    const prevDate = dateFormat(getPrevMonth(viewedDate), "isoDate");
    onMonthChange(prevDate);
  };

  const handleNextMonth = () => {
    const nextDate = dateFormat(getNextMonth(viewedDate), "isoDate");
    onMonthChange(nextDate);
  };

  return (
    <div className={styles.navigate}>
      <button
        className={styles.navigate_button}
        disabled={disablePrevButton}
        onClick={handlePrevMonth}
      >
        <img src={arrowLeftIcon} alt="prev month" />
      </button>
      <div className={styles.navigate_currentDay}>
        <span className={styles.navigate_currentDay_name}>
          {currentDate.monthName} {currentDate.yearName}
        </span>
      </div>
      <button
        className={styles.navigate_button}
        disabled={disableNextButton}
        onClick={handleNextMonth}
      >
        <img src={arrowRightIcon} alt="next month" />
      </button>
    </div>
  );
};
